
<template>
<div style="height:100%">
  <div class="report" v-if="reportShow">
    <h1>沟通状态反馈报告</h1>
    <div class="content">
      <div class="left">
        <div class="video">
            <video :src="videoPath[videoIndex]" @ended='playEnd' id="video"></video>
        </div>
        <div class="left-bottom">
            <div class="text">
                <img src="../assets/img/report/tips_v2.png" alt="">
                <p>建议先回看你的视频，从旁观者的角度感受一下自己的沟通状态！</p>
            </div>
            <div class="btn">
                <img src="../assets/img/report/button_1_v2.png" alt="" @click="playVideo">
                <img src="../assets/img/report/button_2_v2.png" alt="" @click="goScene">
            </div>
        </div>
      </div>
      <div class="right">
        <div class="right-top">
          <div class="part1">
            <div class="part1-1"><img :src="scoreImg" alt=""></div>
            <div class="">
                <h2>{{totalT}}%</h2>
                <h3><span>•</span>{{remarks}}</h3>
                <h4>本次沟通中，您的状态比{{totalT}}%的人优秀哦！</h4>
            </div>
          </div>
          <div class="part2">
              <h5>沟通状态改善小贴士</h5>
              <p v-for="(item,index) in dim_score" :key="index">{{item.improve_advice}}</p>
          </div>
        </div>
        <div class="right-bottom">
          <ul>
            <li v-for="(item,index) in dim_score" :key="index">
              <circle-progress :id="index" :name="dim[item.dimension_id]" :score="item.Tscore"></circle-progress>
              <p>{{item.state_desc}}</p>
            </li>
            <!-- <li>
              <circle-progress :id="'1'" :name="'亲和度'" :score="70"></circle-progress>
              <p>本次沟通中，看得出你有些紧张，不能完整流畅地表达自己的想法，整体表现不够自信。</p>
            </li>-->
          </ul>
        </div>
      </div>
    </div>
    <div class="logo">
      <img src="../assets/img/report/pimc.png" alt="">
    </div>
  </div>
  <div v-if='loading' class="loading">
    <img src="../assets/loading.gif" alt="">
  </div>
</div>
</template>
<script>
import circleProgress from './circle/circle'
export default {
  data () {
    return {
      pimcencypt:localStorage.pimcencypt,
      assess_id:this.$route.query.assess_id||'',
      remarks:'',
      totalT:'',
      dim_score:[],
      dim:{},
      videoPath:[],
      videoIndex:0,
      video:'',
      loading:true,
      reportShow:false,
      scoreImg:'',
      pimcencypt:localStorage.pimcencypt||'',
      userMessage:this.$route.query.u||'',
      realname: '',
      oldMobile: localStorage.CmindLoginMobile||123,
      mobile:'',
    }
  },
  created(){
    // 获取维度
    this.$http.get(`/PcProject/getdimension?${this.getTime()}`).then(res => {
      if(!res.data.code){
        let data = res.data.data
        for(let i in data){
          this.dim[data[i].dimension_id]=data[i].dimension_name
        }
      }
    }).catch(err => {
      this.toast('网络异常',2000)
    })
    //检测登录
    this.login()
  },
  methods:{
    playVideo(){
      this.video = document.getElementById('video');
      setTimeout(() => {
        this.video.play()
      },100);
    },
    playEnd(){
      if(this.videoIndex<this.videoPath.length-1){
        this.videoIndex++
        console.log('视频'+(this.videoIndex+1)+'播放')
        setTimeout(() => {
          this.video.play()
        },100);
      }else{
        this.videoIndex = 0
      }
    },
    goScene(){
        this.$http.get(`/PcProject/checkLogin?${this.getTime()}`,
          {params:{pimcencypt:this.pimcencypt}}
        ).then(res => {
          if(!res.data.code){
            let obj = {realname:res.data.data.realname,mobile:res.data.data.mobile}
            let str = this.base64_encode(JSON.stringify(obj))
            this.$router.push({name: 'index',query: {u:str}})
          }
        }).catch(err => {
            this.toast('返回失败',1000)
        })
        
    },
    getReport(){
      this.$http.get(`/PcProject/getAIreport?${this.getTime()}`,{params:{
        pimcencypt:this.pimcencypt,
        assess_id:this.assess_id,
        is_report:1
      }}).then(res => {
        if(!res.data.code){
          let data = res.data.data
          this.remarks = data.remarks
          this.totalT = data.totalT
          this.dim_score = data.dimension_score
          //计算图片分数高低
          let n = 1
          if(this.totalT<21)
            n = 1
          else if(this.totalT>79)
            n = 8
          else
            n = this.totalT.toString()[0]
          this.scoreImg = require('../assets/img/report/part1_'+n+'.png')
          for(let i in data.question){
            this.videoPath.push(data.question[i].video_path)
          }
          this.reportShow = true
        }else{
          this.toast('报告异常',5000)
        }
        this.loading = false
      }).catch(err => {
        this.toast('获取报告失败',4000)
        this.loading = false
      })
    },
    login(){
      try{
        if(this.userMessage){
          let user = JSON.parse(this.base64_decode((this.userMessage).replace(/[ ]/g,'+')));
          if(user.realname && user.mobile){
            this.realname = user.realname
            this.mobile = user.mobile
            console.log(user)
          }else{
            console.log('不存在realname或mobile')
            alert('地址有误401')
            return
          }
        }else{
          this.getReport()
          return
        }
      }catch(e){
        console.log('参数格式不对:',this.base64_decode(this.userMessage)||'空',e)
        alert('地址有误402')
        return
      }
      // 若当前用户与上一次登录用户不一致，清空pimcencypt
      if(this.mobile!=this.oldMobile){
        this.pimcencypt = ''
      }
      if(!this.pimcencypt){
        this.getPimcencypt().then((e)=>{
          this.$http.post(`/PcProject/register?${this.getTime()}`,
            {realname:this.realname,mobile:this.mobile,pimcencypt:e}
          ).then(res => {
            if(!res.data.code){
              this.getReport()
              localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
            }
          }).catch(err => {
            alert('登录失败，请检查网络')
          })
        }).catch((err)=>{
          alert(err)
        })
      }else{//存在pimcencypt
        this.$http.get(`/PcProject/checkLogin?${this.getTime()}`,
          {params:{pimcencypt:this.pimcencypt}}
        ).then(res => {
          if(!res.data.code){
            this.getReport()
            localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
          }else if(res.data.code==1){
            this.$http.post(`/PcProject/register?${this.getTime()}`,{
              realname:this.realname,
              mobile:this.mobile,
              pimcencypt:this.pimcencypt
            }).then(res => {
              if(!res.data.code){
                this.getReport()
                localStorage.setItem("CmindLoginMobile", res.data.data.mobile);
              }
            }).catch(err => {
                console.log('register登录接口失败')
            })
          }
        }).catch(err => {
            console.log('checkLogin检查登录接口失败')
        })
      }
    },
    getPimcencypt(){
      return new Promise((resolve, reject)=>{
        this.$http.get(`/PcProject/getencypt`).then(res => {
          if(!res.data.code){
            let pimcencypt = res.data.data.pimcencypt
            localStorage.setItem("pimcencypt", pimcencypt);
            this.pimcencypt = pimcencypt
            resolve(pimcencypt);
          }
        }).catch(err => {
            reject("获取信息失败，请检查网络")
        })
      })
    },
  },
  components:{
    circleProgress
  }
}
</script>
<style scoped>
.report{
    height: 100%;box-sizing: border-box;overflow:auto;
    background: url('../assets/img/report/bg_v2.png') no-repeat;
    background-size: cover;padding-top:5%;
    background-position: center;color: #fff;
}
h1{font-size: 30px;color: #fff;margin: 50px 0;}
.content{
  display: flex;max-width: 1120px;margin: 0 auto;min-width: 900px;
  padding: 0 20px; justify-content:space-around;
}
.left{width: 36%;margin-right: 15px;}
.left .video{border: 2px solid #bfbfbf;padding: 10px;}
video{width: 100%;display: block;height: 340px;background: #000;}
.left-bottom{margin-top: 30px;display: flex;}
.left-bottom .text{
    border: 1px dashed #bfbfbf;border-radius: 10px;
    color: #fff;width: 58%;padding: 16px 8px 16px 0;
    display: flex;align-items: center;flex-shrink: 0;
}
.left-bottom .text img{width: 35px;}
.left-bottom .text p{text-align: left;line-height: 1.5;font-size: 16px}
.left-bottom .btn{flex: 1;display: flex; flex-direction:column;justify-content:space-around;}
.left-bottom .btn img{width: 100%;margin-top: -5px;display: block;cursor: pointer;}
.right{width: 660px;}
.right-top{display: flex;}
.part1{
    display: flex;width: 240px;
    background: url('../assets/img/report/bg_1_v2.png') no-repeat;
    background-size: 100% 100%;border-top-left-radius: 20px;
    border-top-right-radius: 20px;text-align: left;
    padding: 14px;margin-right: 15px;flex-shrink: 0;align-items:center;
}
.part1 img{width: 100%;}
.part1 .part1-1{width: 58px;margin-right: 10px;flex-shrink: 0;}
.part1 h2{color: #83c259;font-size: 30px;font-weight: bold;margin-top: 5px;}
.part1 h3{
  font-size: 20px;font-weight: bold;line-height: 48px;
  display: flex;align-items:center;
}
.part1 h3 span{
  color: #83c259;font-size: 30px;display: inline-block;
  width: 16px;line-height: 30px;
}
.part1 h4{line-height: 1.5;margin-top: 1px;}
.part2{
    background: url('../assets/img/report/bg_1_v2.png') no-repeat;
    background-size: 100% 100%;border-top-left-radius: 20px;
    border-top-right-radius: 20px;text-align: left;
    padding: 0 15px 0 25px;
}
.part2 h5{font-weight: bold;font-size: 18px;line-height: 40px;padding-top: 5px;}
.part2 p{line-height: 1.5;position: relative;}
.part2 p::before{
  content: '•';position: absolute;top: 5px;left: -12px;
  font-size: 18px;line-height: 14px;
}
.right-bottom {
    background: url('../assets/img/report/bg_1_v2.png') no-repeat;
    background-size: 100% 100%;border-top-left-radius: 20px;
    border-top-right-radius: 20px;padding: 20px 8px 0;
    margin-top: 20px;
}
.right-bottom ul{display: flex;justify-content: space-around;}
.right-bottom li{padding: 0 10px;box-sizing: border-box;width: 33.3%;}
.right-bottom li p{margin-top: 16px;line-height: 1.5;text-align: justify;font-size: 15px;}
.logo{width: 170px;margin: 50px auto 20px;}
.logo img{width: 100%;}
.loading{width: 60px;position: absolute;left: 50%;top: 10%;margin-left: -30px;}
.loading img{width: 100%}
@media screen and (max-width: 1300px) {
  .report{padding-top: 0}
  .box{margin: 2% auto 0}
}
@media screen and (max-width: 1060px) {
  /* .report{padding-top: 3%} */
  .left-bottom .text p{font-size: 14px}
  .part2 p{font-size: 14px;}
  .logo{width: 150px;}
}
</style>



// WEBPACK FOOTER //
// src/components/report.vue